<template>
  <div class="event-popup-header">
    <div class="event-popup-header__count">残り{{ restCount }}件</div>
    <div class="event-popup-header__header">
      <div class="event-popup-header__header-text-1step">1STEPで申し込み完了！</div>
      <div class="event-popup-header__header-text-recommendation">{{ userLastName }}さんへのおすすめイベント</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'EventPopupHeader',
  props: {
    userLastName: {
      type: String,
      required: true,
    },
    restCount: {
      type: Number,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.event-popup-header__header {
  text-align: center;
}

.event-popup-header__header-text-1step {
  margin-top: 4px;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  color: $oc-white;
}

.event-popup-header__header-text-recommendation {
  margin-top: 4px;
  font-size: 22px;
  font-weight: 600;
  line-height: 33px;
  color: $oc-white;
}

.event-popup-header__panel {
  margin: 35px auto 144px;
  width: 343px;
  background: $oc-white;
  border-radius: 10px;
}

.event-popup-header__image {
  width: 100%;
  border-radius: 10px 10px 0 0;
}

.event-popup-header__body {
  padding: 16px;
}

.event-popup-header__type {
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 12px 4px;
  gap: 4px;
  background: $oc-primary-light60;
  border-radius: 14px;
  font-size: 10px;
  line-height: 150%;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: white;
}

.event-popup-header__title {
  margin-top: 16px;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: $oc-black;
}

.event-popup-header__category {
  display: flex;
  align-items: center;
  margin-top: 16px;
  padding: 8px 0 8px 17px;
  border-left: 4px solid $oc-black;
  font-weight: 300;
  font-size: 14px;
  line-height: 172%;
  letter-spacing: 0.02em;
  color: $oc-black;

  .event-popup-header__category-icon {
    height: 15px;
    margin-right: 9px;
  }
}
.event-popup-header__section {
  margin-top: 16px;
}

.event-popup-header__section-header {
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.02em;
  color: $oc-black;
}

.event-popup-header__section-body {
  font-weight: 300;
  font-size: 14px;
  line-height: 172%;
  letter-spacing: 0.02em;
  color: $oc-black;
}

.event-popup-header__count {
  display: inline-flex;
  align-items: center;
  padding: 0 12px;
  height: 24px;
  border-radius: 12px;
  border: 1px solid $oc-white;
  font-size: 10px;
  font-weight: 600;
  color: $oc-white;
  margin-left: 12px;

  @media screen and (max-width: 768px) {
    margin-left: 0px;
  }
}

.event-popup-header__close {
  position: absolute;
  width: 24px;
  right: 20px;
  top: 20px;
  color: white;
  cursor: pointer;

  @media screen and (max-width: 768px) {
    right: 14px;
    top: 16px;
  }
}

.v-enter {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.25s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
